import $ from 'jquery';
window.jQuery = $;

import ScrollMagic from "./vendor/ScrollMagic.min.js";
import { TweenMax, TimelineMax, Linear} from "gsap"; 
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

const walkingAnimationElement1 = document.getElementById('person-walking-grass');
const walkingAnimationElement2 = document.getElementById('person-walking-court');
const walkingAnimationElement3 = document.getElementById('person-walking-airport');

const startWakingAnimation = () => {
	const obj = { total: 50 };
	const controller = new ScrollMagic.Controller();
	const windowWidth = window.innerWidth;
	const windowHieght = window.innerHeight;
	var topOffest = [25,370,370];
	var topMultiply = [11,10,15];
	var tweenDuration = [600,600,600];

	if(windowWidth <= 769) {
		tweenDuration[0] = 850;
		topMultiply[0] = 19.5;
		tweenDuration[1] = 750;
		topMultiply[1] = 16;
		tweenDuration[2] = 800;
		topMultiply[2] = 18;
	}

	const walkingTween1 = TweenMax.to(obj, 0.5,
		{
			total: 1,
			roundProps: "total",
			immediateRender: true,
			ease: Linear.easeNone,
			onUpdate: function () {
				var animationXValue = (obj.total * 450);
				var topValue = ((49 - obj.total) * topMultiply[0]) + topOffest[0];
				walkingAnimationElement1.style.backgroundPosition = '-150px ' + animationXValue + 'px';
				walkingAnimationElement1.style.top = topValue + 'px';
			}
		}
	);

	const walkingTween2 = TweenMax.to(obj, 0.5,
		{
			total: 1,
			roundProps: "total",
			immediateRender: true,
			ease: Linear.easeNone,
			onUpdate: function () {
				var animationXValue = (obj.total * 450);
				var topValue = ((49 - obj.total) * topMultiply[1]) - topOffest[1];
				walkingAnimationElement2.style.backgroundPosition = '0px ' + animationXValue + 'px';
				walkingAnimationElement2.style.top = topValue + 'px';
			}
		}
	);

	const obj2 = { total: 45 };
	const walkingTween3 = TweenMax.to(obj2, 0.5,
		{
			total: 1,
			roundProps: "total",
			immediateRender: true,
			ease: Linear.easeNone,
			onUpdate: function () {
				var animationXValue = (obj2.total * 450);
				var topValue = ((49 - obj2.total) * topMultiply[2]) - topOffest[2];
				walkingAnimationElement3.style.backgroundPosition = '0px ' + animationXValue + 'px';
				walkingAnimationElement3.style.top = topValue + 'px';

				if (obj2.total < 45) {
					walkingAnimationElement3.style.display = "block";
				}
				else {
					walkingAnimationElement3.style.display = "none";
				}
			}
		}
	);


	const walkAnimation1 = new ScrollMagic.Scene({ triggerElement: "#walking-animation-trigger1", duration: tweenDuration[0] })
		.setTween(walkingTween1)
		//.addIndicators({ name: "1 (starting walking)" })
		.addTo(controller);

	const walkAnimation2 = new ScrollMagic.Scene({ triggerElement: "#walking-animation-trigger2", duration: tweenDuration[1] })
		.offset(-100)
		.setTween(walkingTween2)
		//.addIndicators({ name: "2 (starting walking)" })
		.addTo(controller);

	const walkAnimation3 = new ScrollMagic.Scene({ triggerElement: "#walking-animation-trigger3", duration: tweenDuration[2] })
		.offset(-100)
		.setTween(walkingTween3)
		//.addIndicators({ name: "3 (starting walking)" })
		.addTo(controller);
}

export default () => {
	const url = window.location.href;
	const isEDMode = url.indexOf('ed=1') > -1;
	const animationEnabled = true;

	if(!walkingAnimationElement1) {
		return;
	}

	if (isEDMode || !animationEnabled) {
		walkingAnimationElement1.style.top = "200px";
		walkingAnimationElement2.style.top = "-120px";
		walkingAnimationElement2.style.left = "-240px";
		walkingAnimationElement3.style.top = "100px";
		walkingAnimationElement3.style.display = "block";
		return;
	}
	
	startWakingAnimation();
}
